import { toast } from '@/components/Toaster/Toast';

import type { SessionTypeInDatabase } from './getFirebaseSessionTypes';

import { getFirebaseSessionTypesByIds } from './getFirebaseSessionTypesByIds';
import { getFirebaseSystemConfigByConfigId } from './getFirebaseSystemConfigByConfigId';
import { getFirebaseSystemsByOrganizationId } from './getFirebaseSystemsByOrganizationId';

export const getFirebaseSessionTypesByOrganizationId = async (
  organizationId: string,
): Promise<SessionTypeInDatabase[]> => {
  const systems = await getFirebaseSystemsByOrganizationId(organizationId);

  // combine and filter out duplicated session types
  const uniqueSessionTypeIds = [...new Set(systems?.flatMap((system) => system.sessionTypes))];

  console.log('Unique session types:', uniqueSessionTypeIds);

  if (!uniqueSessionTypeIds || uniqueSessionTypeIds.length === 0) {
    toast({
      variant: 'error',
      title: 'Error fetching systems',
      description: 'Please contact support',
    });
    return [];
  }

  const sessionTypes = await getFirebaseSessionTypesByIds(uniqueSessionTypeIds);

  if (!sessionTypes) {
    toast({
      variant: 'error',
      title: 'Error fetching Session Types',
      description: 'Please contact support',
    });
    return [];
  }

  return sessionTypes;
};
